import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { COLOR, CORNERS, FIXED_INDENTS, MEDIA } from 'vars/index'

/** One `container` from the concept: a single rounded digit tile. */
export const CountdownDigitSC = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 var(--countdownTimerDigitWidth);
  min-width: var(--countdownTimerDigitMinWidth);
  padding: var(--countdownTimerDigitPadding);
  border-radius: var(${CORNERS.CORNERS_20});
  background: var(${COLOR.SURFACE_OPACITY_LIGHT_15});
`

export const CountdownDigitsSC = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: var(--countdownTimerDigitGap);
`

/** One `.Timer item`: the digit tiles of a unit above its label. */
export const CountdownUnitSC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: var(${FIXED_INDENTS.INDENT_10});

  > ${TextBoxSC} {
    /* new/body/caption tracking: 3% of the 16px label font size */
    letter-spacing: 0.48px;
  }
`

export const CountdownSeparatorSC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--countdownTimerDigitPadding)
    var(--countdownTimerSeparatorPaddingInline);
`

export const CountdownTimerSC = styled.div`
  --countdownTimerDigitWidth: 66px;
  --countdownTimerDigitMinWidth: 34px;
  --countdownTimerDigitPadding: var(${FIXED_INDENTS.INDENT_30});
  --countdownTimerSeparatorPaddingInline: var(${FIXED_INDENTS.INDENT_40});
  --countdownTimerDigitGap: var(${FIXED_INDENTS.INDENT_10});

  display: flex;
  align-items: flex-start;

  ${MEDIA.MAX_599} {
    --countdownTimerDigitWidth: 44px;
    --countdownTimerDigitMinWidth: 44px;
    --countdownTimerDigitPadding: var(${FIXED_INDENTS.INDENT_20});
    --countdownTimerSeparatorPaddingInline: var(${FIXED_INDENTS.INDENT_20});
    --countdownTimerDigitGap: var(${FIXED_INDENTS.INDENT_10});

    /* Compact 375-599: larger tiles when days has two digits. */
    min-width: 0;
    max-width: 100%;
    width: max-content;

    &[data-day-digits='3'] {
      --countdownTimerDigitWidth: 36px;
      --countdownTimerDigitMinWidth: 36px;
      --countdownTimerDigitGap: var(${FIXED_INDENTS.INDENT_20});
      --countdownTimerSeparatorPaddingInline: var(${FIXED_INDENTS.INDENT_20});
    }

    ${CountdownUnitSC} {
      flex: 0 0 auto;
    }

    ${CountdownSeparatorSC} {
      flex: 0 0 auto;
    }

    ${CountdownDigitSC} {
      flex: 0 0 var(--countdownTimerDigitWidth);
      padding: var(--countdownTimerDigitPadding) var(${FIXED_INDENTS.INDENT_10});
    }
  }
`
